import {
    CREATE_DATA_SHARE,
    DELETE_DATA_SHARE,
    GET_LIST_DATA_SHARE,
    UPDATE_DATA_SHARE,
    UPDATE_MULTIPLE_DATA_SHARE,
    GET_DETAIL_DATA_SHARE,
    GET_LIST_FIELDS_RECORD,
    GET_ALL_ROLES_USER,
    GET_ALL_GROUP_USER,
    GET_DATA_APP_BY_ID
} from '@/api/modules/share.api';

export default {
    getListShareData({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_LIST_DATA_SHARE({ payload }, successCallback, errorCallback);
    },

    createDataShare({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        CREATE_DATA_SHARE({ payload }, successCallback, errorCallback);
    },

    deleteDataShare({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        DELETE_DATA_SHARE({ payload }, successCallback, errorCallback);
    },
    updateDataShare({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        UPDATE_DATA_SHARE({ payload }, successCallback, errorCallback);
    },

    updateMultipleDataShare({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        UPDATE_MULTIPLE_DATA_SHARE({ payload }, successCallback, errorCallback);
    },

    getDetailDataShare({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_DETAIL_DATA_SHARE({ payload }, successCallback, errorCallback);
    },
    getListFieldRecords({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_LIST_FIELDS_RECORD({ payload }, successCallback, errorCallback);
    },
    getAllRolesUser({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_ALL_ROLES_USER({ payload }, successCallback, errorCallback);
    },
    getAllGroupUser({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_ALL_GROUP_USER({ payload }, successCallback, errorCallback);
    },
    getAllDataAppById({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        GET_DATA_APP_BY_ID({ payload }, successCallback, errorCallback);
    },
    export({ commit, state }, payload) {
        let errorCallback = (error) => {
            if (typeof payload.errorCallback === 'function') {
                payload.errorCallback(error);
            }
        };
        let successCallback = (response) => {
            if (typeof payload.successCallback === 'function') {
                payload.successCallback(response);
            }
        };
        CREATE_DATA_SHARE({ payload }, successCallback, errorCallback);
    }
};
